import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../../utils/common'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'
import { FloatingTooltip } from '../../../../../Floating'
import { ICON_HEIGHT_16 } from '../../../../../Icon'
import Text from '../../../../../Text'
import { getMatchCriterionValueText } from '../../../../RentalPortalMatch'

import {
  QA_NAME_MATCH_SUGGESTION,
  QA_NAME_MATCH_SUGGESTION_ACCEPT,
  QA_NAME_MATCH_SUGGESTION_DISMISS,
} from './ApplicantFitCheckBlockSuggestion.constants'
import {
  getApplicantFitCheckSuggestionTooltip,
  getIsApplicantFitCheckSuggestionDeferred,
} from './ApplicantFitCheckBlockSuggestion.utils'

import * as styles from './ApplicantFitCheckBlockSuggestion.module.css'

import CheckmarkIcon from '../../../../../../icons/checkmark.svg'
import CloseIcon from '../../../../../../icons/close.svg'

function ApplicantFitCheckBlockSuggestion({
  criterion,
  currency,
  isSubmitting,
  suggestion,
  onAccept,
  onDismiss,
}) {
  const { t } = useTranslation()

  const isDeferred = getIsApplicantFitCheckSuggestionDeferred(suggestion)

  return (
    <div
      {...getQaSelector({ value: QA_NAME_MATCH_SUGGESTION })}
      className={styles.ApplicantFitCheckBlockSuggestion}
    >
      <FloatingTooltip
        content={getApplicantFitCheckSuggestionTooltip({ suggestion, t })}
      >
        <Text isSecondary className={styles.value}>
          {getMatchCriterionValueText({
            criterion,
            currency,
            t,
            value: suggestion.value,
          })}
        </Text>
      </FloatingTooltip>
      {isDeferred ? null : (
        <div className={styles.actions}>
          <Button.White
            isGrey
            beforeIconProps={{ Icon: CheckmarkIcon, height: ICON_HEIGHT_16 }}
            className={styles.accept}
            disabled={isSubmitting}
            height={BUTTON_HEIGHT_24}
            qaName={QA_NAME_MATCH_SUGGESTION_ACCEPT}
            tooltip={t('RentalPortal.MatchSuggestionAcceptKey')}
            onClick={onAccept}
          />
          <Button.White
            isGrey
            beforeIconProps={{ Icon: CloseIcon, height: ICON_HEIGHT_16 }}
            className={styles.dismiss}
            disabled={isSubmitting}
            height={BUTTON_HEIGHT_24}
            qaName={QA_NAME_MATCH_SUGGESTION_DISMISS}
            tooltip={t('RentalPortal.MatchSuggestionDismissKey')}
            onClick={onDismiss}
          />
        </div>
      )}
    </div>
  )
}

export default ApplicantFitCheckBlockSuggestion
